import React, { useState, useMemo, useEffect } from 'react'
import {
  CContainer,
  CHeader,
  CRow,
  CCol,
  CHeaderBrand,
  CNavItem,
  CNavLink,
  CButton,
  COffcanvas,
  COffcanvasHeader,
  COffcanvasTitle,
  CCloseButton,
  COffcanvasBody,
  CHeaderNav,
  CImage,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { useLocation } from 'react-router-dom'
import { cilHamburgerMenu, cibFacebookF, cibInstagram, cibYoutube, cibTwitter } from '@coreui/icons'
import logo from 'src/assets/images/ER_horizontal_blanco.png'
import logoNegative from 'src/assets/images/ER_horizontal.png'
import { AppNavCel } from '../components/index'
import { Buscar } from 'src/reusable'
import api from '../api/api'

const AppHeader = () => {
  const location = useLocation()
  const [visible, setVisible] = useState(false)
  const [nav, setNav] = useState([])
  const [size, setSize] = useState(window.innerWidth)
  const basePath = String(process.env.PUBLIC_URL).trim()

  const cambio = () => {
    setSize(window.innerWidth)
  }

  const buscarMenu = () => {
    api.menu().then((response) => {
      if (response.data.code === 200) {
        setNav(response.data.data)
      }
    })
  }

  useEffect(() => {
    setVisible(false)
    window.addEventListener('resize', cambio)
  }, [location])

  useMemo(() => {
    buscarMenu()
  }, [])

  return (
    <>
      <CHeader>
        <div className="w-100 banda-header-superior">
          <CContainer fluid className="container-sitio">
            <CHeaderNav className="h-100 w-100">
              {size <= 767 ? (
                <>
                  <CRow className="w-100">
                    <CCol className="d-flex logo-header-interior-i">
                      <a href={basePath + '/'}>
                        <CImage className="sidebar-brand-full" src={logo} height={35} />
                      </a>
                    </CCol>
                    <CCol className="d-flex logo-header-interior-d">
                      <CButton
                        color="secondary"
                        className="color-btn-menu-celu mt-2"
                        onClick={() => setVisible(true)}
                      >
                        <CIcon icon={cilHamburgerMenu} size="xl" />
                      </CButton>
                    </CCol>
                  </CRow>
                  <COffcanvas placement="end" visible={visible} onHide={() => setVisible(false)}>
                    <COffcanvasHeader>
                      <COffcanvasTitle>
                        <CImage className="sidebar-brand-full" src={logoNegative} height={35} />
                      </COffcanvasTitle>
                      <CCloseButton className="text-reset" onClick={() => setVisible(false)} />
                    </COffcanvasHeader>
                    <COffcanvasBody>
                      <AppNavCel id="header_i" items={nav} base={basePath} />
                    </COffcanvasBody>
                  </COffcanvas>
                </>
              ) : (
                <CRow className="w-100 h-100">
                  <CCol className="logo-header-redes-sitios">
                    <a
                      href="https://www.facebook.com/GobiernoER"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Facebook Gobierno Entre Ríos"
                    >
                      <CIcon
                        icon={cibFacebookF}
                        style={{ marginRight: '0.75rem', color: '#FFF' }}
                        height={15}
                      ></CIcon>
                    </a>
                    <a
                      href="https://www.youtube.com/c/GobiernoER"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="YouTube Gobierno Entre Ríos"
                    >
                      <CIcon
                        icon={cibYoutube}
                        style={{ marginRight: '0.75rem', color: '#FFF' }}
                        height={15}
                      ></CIcon>
                    </a>
                    <a
                      href="https://twitter.com/GobiernoER"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Twitter Gobierno Entre Ríos"
                    >
                      <CIcon
                        icon={cibTwitter}
                        style={{ marginRight: '0.75rem', color: '#FFF' }}
                        height={15}
                      ></CIcon>
                    </a>
                    <a
                      href="https://instagram.com/gobiernoer?igshid=YmMyMTA2M2Y="
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Instagram Gobierno Entre Ríos"
                    >
                      <CIcon icon={cibInstagram} style={{ color: '#FFF' }} height={15}></CIcon>
                    </a>
                  </CCol>
                </CRow>
              )}
            </CHeaderNav>
          </CContainer>
        </div>

        <CContainer fluid className="container-er alto-encabezado-int">
          {size >= 768 ? (
            <>
              <CHeaderBrand href={basePath + '/inicio'}>
                <CImage className="sidebar-brand-full" src={logoNegative} height={80} />
              </CHeaderBrand>
              <div style={{ width: '50%' }}>
                <Buscar tipo="pagina"></Buscar>
              </div>
              <div className="alineado-end w-100 alto-menu-int">
                <CHeaderNav className="menu-int-derecha">
                  {nav.map((_nav, index) =>
                    index === 0 ? (
                      <CNavItem key={'item_' + index}>
                        <CNavLink
                          href={_nav.target === '_blank' ? _nav.to : basePath + _nav.to}
                          target={_nav.target}
                          className={'clase-subrayado-int ' + _nav.classname}
                          key={'link_' + index}
                          active
                        >
                          {_nav.name}
                        </CNavLink>
                      </CNavItem>
                    ) : (
                      <>
                        <CNavItem key={'item_separador_' + index}>
                          <CNavLink
                            className={'clase-subrayado-int'}
                            key={'link_separador_' + index}
                            active
                          >
                            |
                          </CNavLink>
                        </CNavItem>
                        <CNavItem key={'item_' + index}>
                          <CNavLink
                            href={_nav.target === '_blank' ? _nav.to : basePath + _nav.to}
                            target={_nav.target}
                            className={'clase-subrayado-int ' + _nav.classname}
                            key={'link_' + index}
                            active
                          >
                            {_nav.name}
                          </CNavLink>
                        </CNavItem>
                      </>
                    ),
                  )}
                </CHeaderNav>
              </div>
            </>
          ) : (
            <div className="w-100 mb-2">
              <Buscar tipo="home"></Buscar>
            </div>
          )}
        </CContainer>
      </CHeader>
    </>
  )
}
export default AppHeader
